import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 捕获并忽略 ResizeObserver 循环错误
if (typeof ResizeObserver !== 'undefined') {
  const originalObserver = ResizeObserver
  ResizeObserver = class extends originalObserver {
    constructor(callback) {
      super((entries, observer) => {
        try {
          callback(entries, observer)
        } catch (error) {
          // 忽略 ResizeObserver 循环错误
          if (!error.message.includes('ResizeObserver loop')) {
            console.error('ResizeObserver error:', error)
          }
        }
      })
    }
  }
}

// 全局错误处理
window.addEventListener('error', (event) => {
  // 忽略 ResizeObserver 循环错误
  if (event.error && event.error.message && event.error.message.includes('ResizeObserver loop')) {
    event.preventDefault()
  }
})

// 全局未处理的 Promise 错误处理
window.addEventListener('unhandledrejection', (event) => {
  // 忽略 ResizeObserver 循环错误
  if (event.reason && event.reason.message && event.reason.message.includes('ResizeObserver loop')) {
    event.preventDefault()
  }
})

const app = createApp(App)

app.use(router)
app.use(store)
app.use(ElementPlus)

// 全局注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')
